import {
    SITE_SETTINGS_ERROR,
    SITE_SETTINGS_START,
    SITE_SETTINGS_SUCCESS
} from '../../../constants';
import gql from 'graphql-tag'

export function siteSettings() {
    return async (dispatch, getState, { client }) => {

        dispatch({
            type: SITE_SETTINGS_START
        })

        const query = gql`
        query getSiteSettings($type:String){
            getSiteSettings(type:$type){
                results{
                    name
                    value
                }
            }
        }`;

        try {

            const type = "site_settings";
            const { data } = await client.query({
                query,
                variables: { type },
                fetchPolicy: 'network-only'
            })

            let settingsData = {};

            if (data && data.getSiteSettings && data.getSiteSettings.results && data.getSiteSettings.results.length > 0) {

                data.getSiteSettings.results.map((item, key) => {
                    settingsData[item.name] = item.value;
                });


                dispatch({
                    type: SITE_SETTINGS_SUCCESS,
                    data: settingsData
                })


            } else {
                dispatch({
                    type: SITE_SETTINGS_ERROR
                });
            }
        } catch (error) {
            dispatch({
                type: SITE_SETTINGS_ERROR,
            });
        }
    }
}